const primary = '#007a63';

export default {
  primary,
}
